














import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CountrySelect extends Vue {
  @Prop({ default: '' })
  value!: string;

  @Emit()
  input(value: string) {
    return value;
  }
}
